export default "__VITE_ASSET__Z6hcb79e__"